export enum EventRequestSpecialAction {
  rejectAll = 'reject-all',
}
